import React from 'react';
import { useCallback, useEffect, useState } from 'react';
import {
  CarrierOnboardingListRequest,
  useDeleteCarrierOnboardingMutation,
  useFetchCarrierOnboardingsQuery,
} from '../carrieronboarding-api';
import {
  useFetchPartnershipInformationsQuery
} from '../../partnershipinformation/partnershipinformation-api';
import AuditLogsScreen from '../../../components/common/auditLogs';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from '@ant-design/pro-layout';
import {
  Alert,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Space,
  Table,
  Row,
  Col,
  Select
} from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  HomeOutlined,
  MoreOutlined,InfoCircleOutlined
} from '@ant-design/icons';
import {
  FilterValue,
  SorterResult,
  TableCurrentDataSource,
  TablePaginationConfig,
} from 'antd/lib/table/interface';
import { CarrierOnboardingViewModel, PaginatedResult, PartnershipInformationViewModel } from '../../api/models';
import { DefaultPage, DefaultPageSize } from '../../../core/defaults';
import Title from 'antd/lib/typography/Title';
import { getLink } from '../../../App-router';
import { TableState } from '../../../components/table/model';
import getSortBy from '../../../components/table/sorter';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export default function CarrierOnboardingsScreen(props: any) {
  const location = useLocation();
  const query = useQuery();
  const params: any = useParams<any>();
  const navigate = useNavigate();
  const [partnershipId, setPartnershipId] = useState<string>(query.get('id') || '');
  const [carrierSelect, setCarrierSelect] = useState<string>(query.get('carrierName') || '');
  const [partnerIdSelect, setPartnerIdSelect] = useState<string>(query.get('partnerId') || '');  
  const [scacSelect, setScacSelect] = useState<string>(query.get('identifierValue') || '');
  const [hideNewCarrierOnboarding, setHideNewCarrierOnboarding] = useState<boolean>(false);
  const [showAuditLogs, setShowAuditLogs] = useState<boolean>(false);
  const [entityId, setEntityId] = useState<number>(0);
  const [deletingId, setDeletingId] = useState<number | null>(null);

  useEffect(() => {
    const newState = getCurrentState();
    setPagination(newState);
  }, [location.search]);

  const carrieronboardingTable: TableState = {
    columns: [
      {
        title: 'Id',
        dataIndex: '',
        key: 'Id',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <Space>
                <span>{carrieronboarding.id}</span>
              </Space>
          </>
        ),
        sorter: (a, b) => 0,  // Disable client-side sorting, use server-side
        sortOrder: (query.get('sortBy') || '').toLowerCase().includes('id')
          ? ((query.get('sortBy') || '').toLowerCase().includes('desc') ? 'descend' : 'ascend')
          : null,
        fixed: 'left',
      },
      {
        title: 'Name',
        dataIndex: '',
        key: 'carrierName',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.carrierName}</span>
          </>
        ),
        sorter: (a, b) => 0,  // Disable client-side sorting, use server-side
        sortOrder: (query.get('sortBy') || '').toLowerCase().includes('carriername')
          ? ((query.get('sortBy') || '').toLowerCase().includes('desc') ? 'descend' : 'ascend')
          : null,
      },
      {
        title: 'Partner Id',
        dataIndex: '',
        key: 'partnerId',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.partnerId}</span>
          </>
        ),
      },
      {
        title: 'Scac',
        dataIndex: '',
        key: 'scac',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.identifierValue}</span>
          </>
        ),
      },
      {
        title: 'DocumentType',
        dataIndex: '',
        key: 'documentType',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.documentType}</span>
          </>
        ),
        sorter: (a, b) => 0,  // Disable client-side sorting, use server-side
        sortOrder: (query.get('sortBy') || '').toLowerCase().includes('documenttype')
          ? ((query.get('sortBy') || '').toLowerCase().includes('desc') ? 'descend' : 'ascend')
          : null,
      },
      {
        title: 'Source',
        dataIndex: '',
        key: 'source',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.source}</span>
          </>
        ),
      },
      {
        title: 'Target',
        dataIndex: '',
        key: 'target',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.target}</span>
          </>
        ),
      },
      {
        title: 'TestFlag',
        dataIndex: '',
        key: 'testFlag',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.testFlag}</span>
          </>
        ),
      },
      
      {
        title: 'Format',
        dataIndex: '',
        key: 'format',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.format}</span>
          </>
        ),
      },
      {
        title: 'Version',
        dataIndex: '',
        key: 'version',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.version}</span>
          </>
        ),
      },
      {
        title: 'Standard',
        dataIndex: '',
        key: 'standard',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.standard}</span>
          </>
        ),
      },
      {
        title: 'Priority',
        dataIndex: '',
        key: 'priority',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <>
              <span>{carrieronboarding.priority}</span>
          </>
        ),
      }, 
      {
        title: 'Actions',
        key: 'action',
        dataIndex: '',
        fixed:'right',
        render: (carrieronboarding: CarrierOnboardingViewModel) => (
          <Dropdown
            trigger={['click']}
            placement="bottomRight"
            overlay={
              <Menu style={{ padding: '8px 8px' }}>
                <Menu.Item icon={<EditOutlined />} >
                  <Link onClick={() => {localStorage.clear();}}
                    to={getLink('CarrierOnboardingEdit', {
                      tenantId: params.tenantId,
                      Id: carrieronboarding.id,
                      partnershipId:params.id,
                    })}
                  >
                    View
                  </Link>
                </Menu.Item>
                <Menu.Item icon={<InfoCircleOutlined />} key="3">
                <Link to="#" onClick={()=>setShowAuditLogs(true)}>
                    Audit Logs
                  </Link>
                </Menu.Item>
                <Menu.Item
                  icon={<DeleteOutlined />}
                  disabled={!!(deletingId && deletingId === carrieronboarding.id)}
                  onClick={() => {
                    confirm({
                      title: (
                        <span>
                          Delete Partner Onboarding <b>{carrieronboarding.documentType} - {carrieronboarding.source} - {carrieronboarding.target}</b>?
                        </span>
                      ),
                      content:
                        'This will also delete its customers, routing rules, partner EDI X12 records, ' +
                        'connection endpoints and transaction activity. This cannot be undone.',
                      icon: <ExclamationCircleOutlined />,
                      okText: 'Yes',
                      cancelText: 'No',
                      onOk: () => handleDelete(carrieronboarding),
                    });
                  }}
                >
                  {deletingId === carrieronboarding.id ? 'Deleting...' : 'Delete'}
                </Menu.Item>
              </Menu>
            }
          >
            <MoreOutlined />
          </Dropdown>
        ),
      },
    ],
  };
  
  const getCurrentState = (): CarrierOnboardingListRequest => {
    const urlParams = new URLSearchParams(location.search);
    return {
      current: Number(urlParams.get('p')) || DefaultPage,
      carrierName:encodeURIComponent(params.carrierName||''),
      partnerId:encodeURIComponent(params.partnerId||''),
      identifierValue:encodeURIComponent(params.identifierValue||''),
      pageSize: Number(urlParams.get('size')) || DefaultPageSize,
      filter: urlParams.get('q'),
      sortBy: urlParams.get('sortBy') || 'Id Desc',
    };
  };
  // console.log(getCurrentState());
  const [pagination, setPagination] = useState<CarrierOnboardingListRequest>(getCurrentState());

  const {
    data: pagedData = {},
    isFetching,
    error,
  }: {
    data?: PaginatedResult<CarrierOnboardingViewModel> | undefined;
    isFetching?: boolean | undefined;
    error?: any;
  } = useFetchCarrierOnboardingsQuery(getCurrentState());
  
  const [deleteCarrierOnboarding, { isLoading: isDeleteLoading, error: deleteError }] =
    useDeleteCarrierOnboardingMutation();
  const { confirm } = Modal;

  const onCreateNew = useCallback(
    () => navigate(getLink('CarrierOnboardingEdit', { ...params, Id: 'new',partnershipId:params.id })),
    [params, navigate]
  );
  const onGoBack = useCallback(
    () => navigate(getLink('PartnershipInformationList', { ...params })),
    [params, navigate]
  );
  // antd's message API renders its argument as a React node, so anything that is
  // not a string (e.g. a ProblemDetails body) would throw and trip the global
  // ErrorBoundary instead of showing a toast.
  const toDisplayMessage = (value: any, fallback: string): string => {
    if (typeof value === 'string' && value.trim()) return value;
    if (value === null || value === undefined) return fallback;
    if (typeof value === 'object') {
      const candidate = value.message ?? value.detail ?? value.title ?? value.error;
      if (typeof candidate === 'string' && candidate.trim()) return candidate;
      return fallback;
    }
    return String(value);
  };

  const handleDelete = async (carrieronboarding: CarrierOnboardingViewModel) => {
    const idToDelete = carrieronboarding.id ?? 0;
    const label = `${carrieronboarding.documentType} - ${carrieronboarding.source} - ${carrieronboarding.target}`;
    try {
      setDeletingId(idToDelete);
      const response = await deleteCarrierOnboarding({
        carrieronboarding: {
          Id: idToDelete,
          updatedBy: sessionStorage.getItem('userEmail') || '',
        },
      }).unwrap();

      if (response?.status?.toLowerCase() === 'success') {
        message.success(toDisplayMessage(response?.message, `Partner Onboarding ${label} deleted`));
      } else {
        message.error(toDisplayMessage(response?.message, 'Failed to delete partner onboarding'));
      }
    } catch (error: any) {
      console.error('Delete partner onboarding failed', error);
      message.error(toDisplayMessage(error?.data ?? error, 'Failed to delete partner onboarding'));
    } finally {
      setDeletingId(null);
    }
  };
  const {
    data: partnershipInfoValues = {},
  }: {
    data?: PaginatedResult<PartnershipInformationViewModel> | undefined;
  } = useFetchPartnershipInformationsQuery({
      current:1,
      pageSize:1000,
      filter:'',
      sortBy: 'Name Asc',
          
  });
  let partnershipInfoResults = partnershipInfoValues.results??[];
// Filter `option.label` match the user type `input`
const filterOption = (
  input: string,
  option?: { label: string; value: string }
) => (
  option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const handleTableChange = (
    paginationConfig: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<CarrierOnboardingViewModel> | SorterResult<CarrierOnboardingViewModel>[],
    extra: TableCurrentDataSource<CarrierOnboardingViewModel>
  ) => {
    // Handle sorter - it can be null, undefined, a single object, or an array
    const sorterResult = Array.isArray(sorter) ? sorter[0] : sorter;
    const { columnKey, order } = (sorterResult || {}) as SorterResult<CarrierOnboardingViewModel>;

    const defaultSort = 'Id Desc';
    // Read current sort from URL to ensure fresh value
    const urlParams = new URLSearchParams(location.search);
    const currentSortBy = urlParams.get('sortBy') || defaultSort;
    const currentPage = Number(urlParams.get('p')) || 1;
    
    // Determine new page number - ensure it's always a valid number
    let newPage = paginationConfig.current;
    if (!newPage || newPage < 1) {
      newPage = currentPage;
    }
    
    // Determine new sort - always ensure it's a valid string
    let newSortBy: string = defaultSort;

    // Check if we're actually changing sort or just pagination
    const isSortingAction = columnKey && order;
    const isCancellingSort = columnKey && !order && currentSortBy !== defaultSort;
    
    if (isSortingAction) {
      newSortBy = getSortBy(columnKey.toString(), order);
      
      if (newSortBy !== currentSortBy) {
        newPage = 1;
      }
    } else if (isCancellingSort) {
      newSortBy = defaultSort;
      newPage = 1;
    } else {
      // Pagination only - preserve current sort
      newSortBy = currentSortBy || defaultSort;
    }
    
    // Final safety check - ensure newSortBy is never empty
    if (!newSortBy || newSortBy.trim() === '') {
      newSortBy = defaultSort;
    }

    const newUrl = getLink(
      'CarrierOnboardingList',
      { ...params },
      {
        sortBy: newSortBy,
        p: newPage,
        size: paginationConfig.pageSize,
        id: partnershipId,
        carrierName: urlParams.get('carrierName') || '',
        partnerId: urlParams.get('partnerId') || '',
        identifierValue: urlParams.get('identifierValue') || '',
        q: urlParams.get('q') || '',
      }
    );
    
    navigate(newUrl, { replace: false });
  };
  
  return (
    <div>
      <PageHeader
        extra={
            <Space>
                {/* <Button  htmlType="button" onClick={onGoBack}>
                  Go to Patner Information
                  </Button> */}

                  <Button  htmlType="button" disabled={hideNewCarrierOnboarding} data-testid={'create-new-carrieronboarding'} onClick={onCreateNew}>
                  New Partner Onboarding
                  </Button>
                </Space>
        }
        title={
          <Title
            level={4}
            style={{
              marginBottom: 0,
              display: 'inline-block',
            }}
          >
            Partner Onboarding
          </Title>
        }
        breadcrumb={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={getLink('home', { tenantId: params.tenantId })}>
              <HomeOutlined />
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={getLink('cob', { tenantId: params.tenantId })}>
              Dashboard
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item key="partnerinfo">
              <Link to={getLink('PartnershipInformationList', { ...params })}>Partner Information</Link>
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item key="carrieronboardings">
              <Link to={getLink('CarrierOnboardingList', { ...params })}>Partner Onboarding</Link>
            </Breadcrumb.Item> */}
            <Breadcrumb.Item key="carrierName">
              <Link to={getLink('CarrierOnboardingList', { ...params })}>{params.carrierName}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
      >
        <Card>
          {error?.status && (
            <Alert message="Error" description={error.data} type="error" showIcon />
          )}
          {deleteError && (
            <Alert
              message="Error"
              description={toDisplayMessage(
                (deleteError as any)?.data ?? deleteError,
                'Failed to delete partner onboarding'
              )}
              type="error"
              showIcon
            />
          )}
          
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <Table
          scroll={{ x: true }}
            dataSource={pagedData.results}
            rowKey={'id'}
            onChange={handleTableChange}
            pagination={{
              ...pagination,
              total: pagedData.totalCount,
              showTotal: (total) => `Total ${total} items`,
              pageSizeOptions: ["10", "20", "50","100"],
              showSizeChanger: true,
              locale: { items_per_page: " / Page" }
            }}
            columns={carrieronboardingTable.columns}
            loading={isFetching}
            onRow={(record, rowIndex) => {
              return {
                onClick: event => { 
                  setEntityId(record?.id||0);
                },
              };
            }}
          />
        </Space>
        
        </Card>
        {showAuditLogs?<AuditLogsScreen entityId={entityId} entityName={'SplittingRule'} showAuditLogs={setShowAuditLogs}/>:<></>}
      </PageHeader>
    </div>
  );
}
